export default function urlify (string) {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return string.replace(urlRegex, (url) => {
    return '<a href="' + url + '" target="_blank">' + url + '</a>'
  })
}
